import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import Admin from './Admin';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

// /admin yolunda yönetim panelini, diğer her yerde siteyi göster.
const isAdmin = window.location.pathname.replace(/\/+$/, "") === "/admin";
const Root = isAdmin ? Admin : App;

const app = (
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// react-snap pre-renders the home page; hydrate when matching static HTML exists.
// /admin is client-only (no pre-render), so always render fresh to avoid mismatch.
if (!isAdmin && container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  container.innerHTML = "";
  createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
